import React, { useState } from "react";
import cn from "classnames";
import styles from "./Overview.module.sass";
import Card from "../../../../components/Card";
import Stepper from "./Stepper";

const Overview = ({ className, folder, onFolderUpdate }) => {
  // Récupérer les données de progression depuis le folder
  const progression = folder?.progression || {};

  // Calculer l'étape actuelle pour le badge
  const getCurrentStep = () => {
    const etudiant = progression?.etudiant || {};
    const entreprise = progression?.entreprise || {};
    const ecole = progression?.ecole || {};
    
    // Étape 1: Informations élève
    if (!etudiant.infos_remplies) return 1;
    
    // Vérifier si une entreprise est associée
    const hasCompany = folder?.expand?.company_id;
    if (!hasCompany) return 1.5;
    
    // Étape 2: Informations entreprise
    if (!entreprise.infos_remplies || !entreprise.contrat_cree || !entreprise.tuteur_assigne) {
      return 2;
    }
    
    // Étape 3: Génération documents (école)
    if (!ecole.cerfa_genere) return 3;
    
    // Étape 4: Validation par l'école
    if (!ecole.valide_cerfa) return 4;
    
    // Étape 5: Signatures générales
    if (!etudiant.sign || !entreprise.sign || !ecole.sign) return 5;
    
    // Étape 6: Dossier terminé
    return 6;
  };

  const currentStep = getCurrentStep();

  return (
    <Card
      className={cn(styles.card, className)}
      title="Avancée du dossier"
      classTitle="title-red"
      head={
        <span className={cn('status-type', 'status-blue-dark')}>
          Étape {currentStep} sur 6
        </span>
      }
    >
      <div className={styles.overview}>
        <Stepper progression={progression} folder={folder} onFolderUpdate={onFolderUpdate} />
      </div>
    </Card>
  );
};

export default Overview;
